export default "__VITE_ASSET__5b62f4d9__"